import { CultureInfo } from '../culture-info.model';
import { CultureInfoNl } from './nl';

/**
 * @ignore
 */
export const CultureInfoNlBQ: CultureInfo = {
  name: 'nl-BQ',
  displayName: 'Nederlands (Caribisch Nederland)',
  iso3LanguageCode: 'nld',
  iso2LanguageCode: 'nl',
  ietfLanguageTag: 'nl-BQ',
  parent: CultureInfoNl
};
